import { Button, Card, Group, Text } from "@mantine/core";
import { useDisclosure, useForceUpdate } from "@mantine/hooks";
import { IconFilter, IconPlus } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import AddItemButton from "@/components/add-item-button";
import RefreshQueryButton from "@/components/refresh-query-button";
import { THandler } from "@/components/table/Table";
import FilterList from "@/components/table/TableFiltersList";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import TipoDeJogadaTable from "@/modules/tipo-de-jogada/components/tipo-de-jogada-table";
import { QUERY_KEY } from "@/modules/tipo-de-jogada/firestore";
import tipoDeJogadaSchema from "@/modules/tipo-de-jogada/schema/tipo-de-jogada-schema";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import TableFilters from "./TableFilters";
import { dataAutorizacoes } from "../empresa-page/EmpresaPage";

const REFRESH_ALL_KEY = [QUERY_KEY];
// prettier-ignore
const TipoDeJogadaPage = () => {
  const tableHandlersReference = useRef<THandler<TTipoDeJogada>>(null);
  const [opened, { close, toggle }] = useDisclosure(false);
  const queryClient = useQueryClient();
  const activeEmpresaId = useUserStore((store) => store.activeEmpresa);
  const activeAutorizacao = useUserStore((store) => store.autorizacoes);
  const uid = getCurrentUser()?.uid;
  const { data: userColaborador } = useGetColaboradorById(activeEmpresaId?.id || "", uid || "");

  const autorizacao = dataAutorizacoes.find(item => item.label === userColaborador?.role);
  const formatAutorizacoes = activeAutorizacao?.filter(item => item.tipo === autorizacao?.value);
  const forceUpdate = useForceUpdate();
  /**
   * Handle filter applied
   */
  function handleFilterApplied() {
    close();
    void queryClient.invalidateQueries({ queryKey: REFRESH_ALL_KEY }).then(() => forceUpdate());
  }

  return (
    <Card
      withBorder
      shadow="md"
      styles={{
        section: {
          overflow: "auto"
        }
      }}
    >
      <Card.Section px="md" py="xs" withBorder>
        <Group justify="space-between">
          <Text fw={500} fz="lg">
            Listagem de tipos de jogada
          </Text>
          {formatAutorizacoes?.find(item => item.tipoAutorizacao === "12")?.criacao ? <Group>
            <AddItemButton
              size="sm"
              leftSection={<IconPlus size="1rem" />}
              modalProperties={{ modal: "tipo-de-jogada-form-modal" }}
              schema={tipoDeJogadaSchema}
            >
              Adicionar
            </AddItemButton>
          </Group> : <></>}
        </Group>
      </Card.Section>
      <Card.Section inheritPadding py="md" withBorder>
        <Group justify="space-between">
          <Group align="center">
            <Button variant="subtle" size="compact-md" onClick={toggle} leftSection={<IconFilter size="1rem" />}>
              Filtros
            </Button>
            {tableHandlersReference.current && <FilterList filters={tableHandlersReference.current.filters} />}
          </Group>
          <RefreshQueryButton queryKey={REFRESH_ALL_KEY} />
        </Group>
        {tableHandlersReference.current && (
          <TableFilters
            table={tableHandlersReference.current.table}
            filters={tableHandlersReference.current.filters}
            onClose={close}
            onFilterApplied={handleFilterApplied}
            opened={opened}
          />
        )}
      </Card.Section>
      <TipoDeJogadaTable ref={tableHandlersReference} />
    </Card>
  );
};

TipoDeJogadaPage.displayName = "TipoDeJogadaPage";

export default TipoDeJogadaPage;
